import React from 'react';
import { Flex, Box, Link } from 'rebass';
import { navigate } from '@reach/router';
import Github from './svgs/github';
import Check from './svgs/check';
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import styled from 'styled-components';


const ItStyled = styled.div`
  .gatsby-image-wrapper {
    margin: 0;
    padding: 0;
  }
`;

export default (props) => {
  const data = useStaticQuery(graphql`
    query {
      cranpi: file(relativePath: { eq: "cranpi.png" }) {
        childImageSharp {
          fluid(maxWidth: 300) {
            ...GatsbyImageSharpFluid
          }
        }
      }


    }
  `)
  return (
    <Flex
      width={['20vw', '10vw']}
      py={2}
      px={3}
      height="30vh"
      color='#39375b'
      bg='#3F4347'
      flexDirection='column'
      fontSize='14px'
      alignItems='center'
      justifyContent='space-evenly'
      style={{
        position: 'sticky',
        top: '0%',
        left: '0%',
        zIndex: 12,
      }}
      onClick = {() => navigate(`#${props.nav}`)}
    >
      <Link href='https://github.com/Nukki/HolidayHackChallenge2019' rel="noopener noreferrer" target="_blank" target="_blank">
        <Flex height='10vh' alignItems='center' justifyContent='center'>
          <Github />
        </Flex>
      </Link>

      <Link href='#objectivess'>
        <Flex height='10vh'alignItems='center' justifyContent='center'>
          <Check height='10vh' />
        </Flex>
      </Link>


      <Link href='#terminals'>
        <Box height='10vh'>
          <ItStyled>
            <Img fluid={data.cranpi.childImageSharp.fluid}
                    style={{ margin: 0,  maxHeight: '8vh', width: '8vh' }}
                    imgStyle={{ objectFit: 'contain' }}
            />
          </ItStyled>
        </Box>
      </Link>

    </Flex>
  )
}
